// weight-sort.js — grid-aware + url-change + safe observer
(function () {
  const GRID_SELECTOR = "[data-product-grid]";
  let ranOnce = false;
  let mo = null;
  let sorting = false;
  let debTimer = null;

  function getGrid() {
    return document.querySelector(GRID_SELECTOR);
  }

  function shouldSort() { return true; } // 一律依權重排

  function log(...args){ try{ console.log("[weight-sort]", ...args);}catch(e){} }

  function sortByWeight() {
    if (!shouldSort()) return;
    const grid = getGrid();
    if (!grid) return;

    // 避免重入
    if (sorting) return;
    sorting = true;

    // 排序時先暫停監聽，避免我們自己的 DOM 變動又觸發一次
    if (mo) mo.disconnect();

    const lis = Array.from(grid.querySelectorAll(":scope > li"));
    if (!lis.length) { sorting = false; observeGrid(); return; }

    const rows = lis.map((li, idx) => {
      const card = li.querySelector("product-card");
      const w = card && card.dataset
        ? Number((card.dataset.weight || "0").trim())
        : 0;
      return { li, w, idx };
    });

    rows.sort((a, b) => b.w - a.w || a.idx - b.idx);

    const frag = document.createDocumentFragment();
    rows.forEach(({ li }) => frag.appendChild(li));
    grid.appendChild(frag);

    ranOnce = true;
    sorting = false;

    // 排完恢復監聽
    observeGrid();
    log("sorted");
  }

  function scheduleSort() {
    if (!shouldSort()) return;
    clearTimeout(debTimer);
    debTimer = setTimeout(sortByWeight, 80);
  }

  function observeGrid() {
    const grid = getGrid();
    if (!grid) return;

    if (!mo) {
      mo = new MutationObserver(records => {
        // 只有偵測到直接子層有新增/移除節點才觸發（主題 AJAX 會替換 / 追加 <li>）
        const changed = records.some(r => r.type === "childList" && (r.addedNodes.length || r.removedNodes.length));
        if (changed) scheduleSort();
      });
    }
    // 只監聽 childList，且只對 UL 本身
    mo.observe(grid, { childList: true });
  }

  // 監聽 URL 變化（很多主題在篩選時會用 pushState/replaceState）
  (function patchHistory(){
    const _ps = history.pushState;
    const _rs = history.replaceState;
    function fire() { window.dispatchEvent(new Event("weight-sort:urlchange")); }
    history.pushState = function(){ const r=_ps.apply(this, arguments); fire(); return r; };
    history.replaceState = function(){ const r=_rs.apply(this, arguments); fire(); return r; };
    window.addEventListener("popstate", fire);
    window.addEventListener("weight-sort:urlchange", scheduleSort);
  })();

  function init() {
    if (!getGrid()) return;
    sortByWeight();   // 初次
    observeGrid();    // 之後 AJAX/無限捲動/換頁都會再觸發
  }

  // 常見主題事件（含你的 theme 自帶的 custom-pagination 族）
  document.addEventListener("DOMContentLoaded", init);
  window.addEventListener("load", scheduleSort);
  document.addEventListener("shopify:section:load", scheduleSort);
  document.addEventListener("custom-pagination:updated", scheduleSort);
  document.addEventListener("custom-pagination:loaded", scheduleSort);
  document.addEventListener("custom-pagination:append", scheduleSort);

  // 安全保險：前 2 秒每 200ms 看一次，成功一次就停
  let tries = 0, maxTries = 10;
  const t = setInterval(() => {
    if (ranOnce) return clearInterval(t);
    tries += 1; init();
    if (tries >= maxTries) clearInterval(t);
  }, 200);
})();
